import { aprobarFactura, rechazarFactura, editarEstadoFactura } from "../../../services/compra.services.js";
import formatCurrency from "../../../common/utils/functions/formatCurrencyForUi.js";

/**
 * Configuración de acciones para el modal de factura
 * Cada configuración define el comportamiento del modal según la acción
 */
export const MODAL_ACTION_CONFIG = {
  aprobado: {
    title: "Aprobar factura",
    description: ({ formattedAmount, userDetails }) => {
      // Si el usuario tiene permisos de compra, va a Cuentas a Pagar
      // Si el usuario es de gerencia, va a Compras
      const isComprasUser = !!userDetails?.userPurchasePermissions;
      const nextDepartment = isComprasUser ? "Cuentas a Pagar" : "Compras";
      return `Si la aprobás, será enviada a ${nextDepartment} para continuar el proceso.`;
    },
    variant: 'info',
    messageHeaderVariant: 'warning',
    commentRequired: false,
    minCommentLength: 0,
    buttonText: 'Aprobar',
    height: "470px",
    serviceFn: aprobarFactura,
    newStatus: 'Aprobado',
    icon: 'warning'
  },
  
  rechazado: {
    title: "Rechazar factura",
    description: ({ typeInvoice, formattedAmount, razonSocial }) => 
      `Si la rechazás, dejará de avanzar en el proceso y será enviada a Mesa de Entradas.`,
    variant: 'error',
    messageHeaderVariant: 'warning',
    commentRequired: true,
    minCommentLength: 8,
    buttonText: 'Rechazar',
    height: "500px",
    serviceFn: rechazarFactura,
    newStatus: 'Rechazado',
    icon: 'warning'
  },
  
  "en progreso": {
    title: 'Vas poner una factura en estado "En progreso"',
    description: () => 
      'Si continuas, el equipo de gerencia podrá ver que la factura se encuentra en análisis',
    variant: 'info',
    messageHeaderVariant: 'warning',
    commentRequired: true,
    minCommentLength: 8,
    buttonText: 'Confirmar',
    height: "500px",
    serviceFn: (id, comentario, username, centroCosto) => 
      editarEstadoFactura(id, 'En progreso', comentario, username, centroCosto),
    newStatus: 'En progreso',
    icon: 'warning',
    titleClassName: 'text-center'
  }
};


export const getActionConfig = (mode) => {
  const normalizedMode = String(mode || 'aprobado').toLowerCase();
  return MODAL_ACTION_CONFIG[normalizedMode] || MODAL_ACTION_CONFIG.aprobado;
};


export const getDescriptionContext = ({ amount, typeInvoice, razonSocial, userDetails }) => ({
  formattedAmount: formatCurrency(amount),
  typeInvoice,
  razonSocial,
  userDetails
});
